module.exports = __webpack_public_path__ + "static/img/sport_bg0.b6548537.jpg";